/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateContentFilteringMutationRequest,
  UpdateContentFilteringMutationResponse,
  UpdateContentFilteringPathParams,
} from "../types/UpdateContentFiltering.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateContentFilteringMutationKey = () =>
  [
    {
      url: "/v1/organization-settings/update-content-filtering/:productSheetGroupId",
    },
  ] as const

export type UpdateContentFilteringMutationKey = ReturnType<
  typeof updateContentFilteringMutationKey
>

/**
 * @summary Update content filtering settings
 * {@link /v1/organization-settings/update-content-filtering/:productSheetGroupId}
 */
export async function updateContentFiltering(
  productSheetGroupId: UpdateContentFilteringPathParams["productSheetGroupId"],
  data: UpdateContentFilteringMutationRequest,
  config: Partial<RequestConfig<UpdateContentFilteringMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateContentFilteringMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateContentFilteringMutationRequest
  >({
    method: "PUT",
    url: `/v1/organization-settings/update-content-filtering/${productSheetGroupId}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateContentFilteringMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateContentFilteringMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateContentFilteringMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateContentFilteringMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateContentFilteringPathParams["productSheetGroupId"]
      data: UpdateContentFilteringMutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ productSheetGroupId, data }) => {
      return updateContentFiltering(productSheetGroupId, data, config)
    },
  })
}

/**
 * @summary Update content filtering settings
 * {@link /v1/organization-settings/update-content-filtering/:productSheetGroupId}
 */
export function useUpdateContentFiltering<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateContentFilteringMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        productSheetGroupId: UpdateContentFilteringPathParams["productSheetGroupId"]
        data: UpdateContentFilteringMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateContentFilteringMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateContentFilteringMutationKey()

  const baseOptions = updateContentFilteringMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateContentFilteringMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateContentFilteringPathParams["productSheetGroupId"]
      data: UpdateContentFilteringMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateContentFilteringMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateContentFilteringPathParams["productSheetGroupId"]
      data: UpdateContentFilteringMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateContentFilteringMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateContentFilteringPathParams["productSheetGroupId"]
      data: UpdateContentFilteringMutationRequest
    },
    TContext
  >
}
